import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/data";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 bg-concrete text-ink"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
          <div className="max-w-2xl">
            <span className="tech-rule">02 — Services</span>
            <h2
              data-testid="services-heading"
              className="mt-6 font-heading font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.9] tracking-tighter"
            >
              Seven disciplines.<br />
              <span className="italic font-medium text-rust">One commitment.</span>
            </h2>
          </div>
          <p className="md:max-w-sm text-graphite leading-relaxed">
            From sub-grade to final kerb, every scope is engineered, supervised
            and delivered in-house — backed by our own asphalt plant.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border border-ink">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.code} service={s} index={i} />
          ))}
          <div className="hidden lg:flex p-8 md:p-10 bg-ink text-bone items-end justify-between">
            <div>
              <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-rust mb-3">
                Need a custom scope?
              </div>
              <h3 className="font-heading font-bold text-2xl tracking-tight leading-tight">
                Let's scope it together.
              </h3>
            </div>
            <a
              href="#contact"
              data-testid="services-cta"
              className="border border-bone w-12 h-12 grid place-items-center hover:bg-bone hover:text-ink transition-colors"
            >
              <ArrowUpRight className="w-5 h-5" strokeWidth={2} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ service, index }) {
  return (
    <div
      data-testid={`service-card-${service.code}`}
      className="group relative p-8 md:p-10 bg-bone border-ink border-b border-r [&:nth-child(3n)]:md:border-r-0 [&:last-child]:border-b-0 hover:bg-ink hover:text-bone transition-colors duration-300"
    >
      <div className="flex items-start justify-between mb-6">
        <span className="font-mono text-[11px] tracking-[0.22em] text-rust">
          / {service.code}
        </span>
        <ArrowUpRight
          className="w-5 h-5 opacity-30 group-hover:opacity-100 group-hover:rotate-0 -rotate-45 transition-all"
          strokeWidth={2}
        />
      </div>
      <h3 className="font-heading font-bold text-2xl md:text-3xl tracking-tight leading-tight mb-4">
        {service.title}
      </h3>
      <p className="text-sm leading-relaxed text-graphite group-hover:text-bone/75 transition-colors">
        {service.desc}
      </p>
      <div className="mt-6 flex flex-wrap gap-2">
        {service.tags.map((t) => (
          <span
            key={t}
            className="font-mono text-[10px] tracking-widest uppercase px-2.5 py-1 border border-graphite/40 text-graphite group-hover:border-bone/40 group-hover:text-bone/70"
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  );
}
